import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
import _imports_0 from '../assets/min-main-logo.png';
var _hoisted_1 = { class: "back-button" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "home-logo" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: ""
    })
], -1);
var _hoisted_3 = {
    key: 0,
    class: "no-info"
};
var _hoisted_4 = { class: "info-card-container" };
var _hoisted_5 = { class: "cards" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold");
    var _component_el_icon = _resolveComponent("el-icon");
    var _component_router_link = _resolveComponent("router-link");
    var _component_CustomSelect = _resolveComponent("CustomSelect");
    var _component_BikeLaneInfoCard = _resolveComponent("BikeLaneInfoCard");
    var _component_BaseLayout = _resolveComponent("BaseLayout");
    return (_openBlock(), _createBlock(_component_BaseLayout, { class: "find-bike-lane" }, {
        header: _withCtx(function () { return [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_icon, { onClick: _ctx.goBack }, {
                    default: _withCtx(function () { return [
                        _createVNode(_component_ArrowLeftBold)
                    ]; }),
                    _: 1
                }, 8, ["onClick"])
            ]),
            _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(function () { return [
                    _hoisted_2
                ]; }),
                _: 1
            }),
            _createVNode(_component_CustomSelect, {
                width: "143px",
                height: "31px",
                options: _ctx.taiwanLocationList,
                onInput: _ctx.getSelectedOption,
                default: "選擇縣市"
            }, null, 8, ["options", "onInput"])
        ]; }),
        body: _withCtx(function () { return [
            (_ctx.bikeLanesInfo.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "尚未選擇任何縣市"))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bikeLanesInfo, function (bikeLane) {
                        return (_openBlock(), _createBlock(_component_BikeLaneInfoCard, {
                            key: bikeLane.StationUID,
                            info: bikeLane,
                            onClick: function ($event) { return (_ctx.checkLaneMap(bikeLane)); }
                        }, null, 8, ["info", "onClick"]));
                    }), 128))
                ])
            ])
        ]; }),
        _: 1
    }));
}
